import { render, staticRenderFns } from "./FormMilkControl.vue?vue&type=template&id=16822534&scoped=true&"
import script from "./FormMilkControl.vue?vue&type=script&lang=js&"
export * from "./FormMilkControl.vue?vue&type=script&lang=js&"
import style0 from "./FormMilkControl.vue?vue&type=style&index=0&id=16822534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16822534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VPagination,VSelect,VSwitch,VTextField})
